import { Box, IconButton, useTheme } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SwitchAccountBtn } from 'src/components';
import UserAction from 'src/components/streametric/user-action/UserAction';
import { TENANT_SWITCH_PATH } from 'src/routes/config';
import { EditTitleBox } from '../extendedHeader/components';
import { TitleWithEditBox } from 'src/components/streametric/titleWithEditBox/TitleWithEditBox';
import { useResponsive } from 'src/hooks/useResponsive';
import { ListIcon } from 'src/assets/icons/ListIcon';
import { useCustomDashboardContext } from 'src/contexts/customDashboardContext/customDashboard.context';

export const BaseHeader = () => {
  const { title, onConfirmTitleHandler } = useCustomDashboardContext();
  const isMobile = useResponsive('down', 'md');
  const theme = useTheme();

  const greenColor = theme.palette.success.main;
  const greyColor = theme.palette.grey[500];

  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const toggleEditHandler = () => {
    setIsEditMode((prevState) => !prevState);
  };

  return (
    <Box
      sx={{
        marginTop: '21px',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '12px 0',
        alignItems: 'center',
      }}
    >
      {isEditMode ? (
        <EditTitleBox
          value={title}
          greenColor={greenColor}
          onCloseEditMode={() => setIsEditMode(false)}
          toggleEditHandler={(newTitle) => {
            onConfirmTitleHandler(newTitle);
            toggleEditHandler();
          }}
        />
      ) : (
        <Box>
          <TitleWithEditBox
            greyColor={greyColor}
            title={title}
            toggleEditHandler={toggleEditHandler}
          />
        </Box>
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', gap: '40px' }}>
        {isMobile ? (
          <IconButton to={TENANT_SWITCH_PATH} component={Link}>
            <ListIcon width={24} height={24} />
          </IconButton>
        ) : (
          <SwitchAccountBtn />
        )}
        <UserAction />
      </Box>
    </Box>
  );
};
